import { render, staticRenderFns } from "./SampleFilterComma.vue?vue&type=template&id=0119bd5e&scoped=true&"
import script from "./SampleFilterComma.vue?vue&type=script&lang=js&"
export * from "./SampleFilterComma.vue?vue&type=script&lang=js&"
import style0 from "./SampleFilterComma.vue?vue&type=style&index=0&id=0119bd5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119bd5e",
  null
  
)

export default component.exports